import { styled } from "@stitches/react";

export const Container = styled("div", {
  width: "100%",
});

export const AdherenceContainer = styled("div", {
  width: "100%",
  height: "860px",

  backgroundColor: "$white",
  borderRadius: "8px",
  margin: "8px 0 64px 0",

  border: "1px solid $gray-40",
});

export const DayNavigator = styled("div", {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  width: "180px",
  height: "24px",
  borderRadius: "8px",

  margin: "12px 0 24px 66px",

  border: "1px solid $gray-40",
});
export const DayButton = styled("div", {
  width: "50%",
  height: "100%",

  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  cursor: "pointer",
  userSelect: "none",

  fontSize: "10px",
  fontFamily: "$openSans",
  fontWeight: 500,
  color: "$gray-80",

  transition: "background-color 0.2s ease, color 0.2s ease, opacity 0.2s ease",

  "&:hover": {
    backgroundColor: "$gray-30",
  },

  variants: {
    disabled: {
      true: {
        opacity: 0.5,
        cursor: "not-allowed",
        pointerEvents: "none",
        backgroundColor: "$gray-20",
        color: "$gray-60",
      },
    },
  },
});

export const Divider = styled("div", {
  width: "1px",
  height: "24px",

  backgroundColor: "$gray-40",
});
